import { keepPreviousData } from '@tanstack/react-query';
import { FetchJsonError } from './fetchJson.js';

export const STABLE_RESOURCE_STALE_TIME_MS = 5 * 60_000;
export const DEFAULT_QUERY_GC_TIME_MS = 30 * 60_000;

export const SHORT_LIVED_RESOURCE_STALE_TIME_MS = 30_000;
export const PROJECT_LISTING_STATS_STALE_TIME_MS = 15_000;

export const keepPreviousResourceData = keepPreviousData;

export function shouldRetryDefaultQuery(failureCount: number, error: unknown): boolean {
  return failureCount === 0 && error instanceof FetchJsonError && error.retryable === true;
}
